
import { Dialog, DialogType, DialogFooter, PrimaryButton, Text } from '@fluentui/react';

interface Props {
    title: string;
    message: string;
    details?: string;
    onDismiss: () => void;
}

export default function ErrorDialog({ title, message, details, onDismiss }: Props) {
    return (
        <Dialog
            hidden={false}
            onDismiss={onDismiss}
            dialogContentProps={{
                type: DialogType.close,
                title,
            }}
            modalProps={{ isBlocking: true }}
        >
            <Text>{message}</Text>
            {details && (
                <pre style={{ marginTop: 12, padding: 8, background: 'var(--ab-bg-elevated)', borderRadius: 4, fontSize: 12, overflow: 'auto', maxHeight: 200 }}>
                    {details}
                </pre>
            )}
            <DialogFooter>
                <PrimaryButton text="OK" onClick={onDismiss} />
            </DialogFooter>
        </Dialog>
    );
}
